/**
 * API service for the Leaderboard page
 */
import { API_GATEWAY_PROCESS_NAME } from "../../utils/constants";
import { apiRequest } from "../../services/apiMiddleware";
import { LeaderboardData } from "./model";
import { logOperationalMetric, MetricType, RCC_SHIFT_PLAN_LEADERBOARD_PAGE, GET_LEADERBOARD_API } from "../../utils/metric-utils";

/**
 * Get leaderboard data from the GetLeaderboard facade API
 * @param warehouseId The site/warehouse code (e.g., "IAH1")
 * @returns Promise with the leaderboard response
 */
export const getLeaderboard = async (warehouseId: string): Promise<LeaderboardData> => {
  const startTime = Date.now();
  const requestPayload = {
    resourcePath: "/getLeaderboard",
    httpMethod: "post",
    processName: API_GATEWAY_PROCESS_NAME,
    requestBody: { warehouseId },
  };

  try {
    const response = await apiRequest(requestPayload);
    logOperationalMetric(startTime, warehouseId, RCC_SHIFT_PLAN_LEADERBOARD_PAGE, GET_LEADERBOARD_API, MetricType.SUCCESS);
    return response.data;
  } catch (error: any) {
    logOperationalMetric(startTime, warehouseId, RCC_SHIFT_PLAN_LEADERBOARD_PAGE, GET_LEADERBOARD_API, MetricType.FAILED, error);
    throw error;
  }
};
